<template>
  <div id="loader"></div>

  <div class="col-md-12 text-center">
    <img
      class="img-fluid mt-4"
      id="logo"
      alt="rtplogo"
      src="https://dev-checkin.veinspracticesolution.com/assets/images/rtplogo.png"
      width="100"
    />
   
    <img
      v-if="paymentMethod==1"
      class="img-fluid mt-4"
      id="logo"
      alt="rtplogo"
      src="https://dev-checkin.veinspracticesolution.com/assets/images/authorize.gif"
      width="100"
    />
  </div>
  <section v-if="paymentMethod==1" id="step-0" class="section active m-b-40" style="margin-top: 70px">
    <div class="container form-container slide">
      <div class="col-12" id="strips1">
        <h4 class="font-weight-bold my-3 text-center">
          Payment Receipt: Credit Card
        </h4>
      </div>
      <table class="table table-striped">
        <tbody>
          <tr>
            <th class="font-weight-bold">Patient Name</th>
            <td id="td1">{{name}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Date Of Birth</th>
            <td id="td1">{{dob}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Date of Service:</th>
            <td id="td1">{{dos}}</td>
          </tr>
          <!-- <tr>
                      <th class="font-weight-bold">Products:</th>
                      <td id="td1">Med</td>
                    </tr> -->
          <tr>
            <th class="font-weight-bold">Sent By:</th>
            <td id="td1">{{sentByName}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Sent Date:</th>
            <td id="td1">{{sentDate}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Paid Date:</th>
            <td id="td1">{{paidDate}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Card Number:</th>
            <td id="td1">{{cardNumber}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Expiration Date:</th>
            <td id="td1">{{expirationDate}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Amount:</th>
            <td id="td1">${{amount}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Notes:</th>
            <td id="td1">{{notes}}</td>
          </tr>
           <tr v-if="refundAmount!==null">
            <th class="font-weight-bold">Refund Amount:</th>
            <td id="td1">${{refundAmount}}</td>
          </tr>
          <tr v-if="refundAmount!==null">
            <th class="font-weight-bold">Refund Date:</th>
            <td id="td1">{{refundDate}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section v-else-if="paymentMethod==3" id="step-1" class="section active m-b-40" style="margin-top: 70px">
    <div class="container form-container slide">
      <div class="col-12" id="strips1">
        <h4 class="font-weight-bold my-3 text-center">
          Payment Receipt: Cheque
        </h4>
      </div>
      <table class="table table-striped">
        <tbody>
          <tr>
            <th class="font-weight-bold">Patient Name</th>
            <td id="td1">{{name}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Date Of Birth</th>
            <td id="td1">{{dob}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Date of Service:</th>
            <td id="td1">{{dos}}</td>
          </tr>
          <!-- <tr>
                      <th class="font-weight-bold">Products:</th>
                      <td id="td1">Med</td>
                    </tr> -->
          <tr>
            <th class="font-weight-bold">Sent By:</th>
            <td id="td1">{{sentByName}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Sent Date:</th>
            <td id="td1">{{sentDate}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Paid Date:</th>
            <td id="td1">{{paidDate}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Cheque Holder Name:</th>
            <td id="td1">{{chequeHolderName}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Cheque Number:</th>
            <td id="td1">{{chequeNumber}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Amount:</th>
            <td id="td1">${{amount}}</td>
          </tr>
           <tr v-if="refundAmount!==null">
            <th class="font-weight-bold">Refund Amount:</th>
            <td id="td1">${{refundAmount}}</td>
          </tr>
          <tr v-if="refundAmount!==null">
            <th class="font-weight-bold">Refund Date:</th>
            <td id="td1">{{refundDate}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section v-else-if="paymentMethod==2" id="step-2" class="section active m-b-40" style="margin-top: 70px">
    <div class="container form-container slide">
      <div class="col-12" id="strips1">
        <h4 class="font-weight-bold my-3 text-center">Payment Receipt: Cash</h4>
      </div>
      <table class="table table-striped">
        <tbody>
          <tr>
            <th class="font-weight-bold">Patient Name</th>
            <td id="td1">{{name}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Date Of Birth</th>
            <td id="td1">{{ dob}}</td>
          </tr>
          <!-- <tr>
                      <th class="font-weight-bold">Products:</th>
                      <td id="td1">Med</td>
                    </tr> -->
          <tr>
            <th class="font-weight-bold">Date of Service:</th>
            <td id="td1">{{dos}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Collection Date:</th>
            <td id="td1">{{paidDate}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Collected By:</th>
            <td id="td1">{{collectedBy}}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Amount:</th>
            <td id="td1">${{amount}}</td>
          </tr>
          <tr v-if="refundAmount!==null">
            <th class="font-weight-bold">Refund Amount:</th>
            <td id="td1">${{refundAmount}}</td>
          </tr>
          <tr v-if="refundAmount!==null">
            <th class="font-weight-bold">Refund Date:</th>
            <td id="td1">{{refundDate}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section id="step-3" class="section active m-b-40" style="margin-top: 70px">
    <div class="container form-container slide">
      <h3 class="text-center boldText">
        THANK YOU FOR VISITING<br />
        VEINS
      </h3>
    </div>
  </section>
</template>

<script>
import axios from "axios";
// import { mapGetters } from "vuex";
export default {
  data() {
    return {
      name:"",
      dob:'',
      dos:'',
      sentByName:'',
      sentDate:'',
      paidDate:'',
      amount:'',
      paymentMethod:'',
      holderName: '',
      tdnumber:'',
      cardNumber:'',
      expirationDate:'',
      notes:'',
      chequeHolderName:'',
      chequeNumber:'',
      collectedBy:'',
      refundAmount:null,
      refundDate:null
    };
  },
  methods: {
    loadinit() {
      var ownerPatientEncode = this.$route.query.Reccheck;
      var ownerPatientDecode = JSON.parse(atob(ownerPatientEncode));
      this.getAxiosGetReceipt(ownerPatientDecode);
    },
    async getAxiosGetReceipt(Data) {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      const Url = this.SERVER + "/VNSPRAAPI/Payments/GetPaymentReceipt";
      await axios({
        method: "post",
        data: Data,
        url: Url,
      })
        .then((res) => {
          this.nextBtn = true;
          debugger; // eslint-disable-line no-debugger
          const rp = res.data.data;
          if (res.data.status) {
            this.name =rp.name;
            this.dob = rp.doBstr;
            this.dos = rp.doSstr;
            this.sentByName = rp.sentByName;
            this.sentDate = rp.sentDatestr;
            this.paidDate = rp.paidDatestr;
            this.amount = rp.amount;
            this.paymentMethod =rp.paymentMethod;
            this.holderName = rp.holderName;
            this.tdNumber = rp.tdNumber;
            this.cardNumber = rp.cardNumber;
            this.expirationDate =rp.expirationDate;
            this.notes = rp.notes ;
            this.chequeHolderName = rp.chequeHolderName;
            this.chequeNumber = rp.chequeNumber;
            this.collectedBy = rp.collectedBy;
            this.refundAmount = rp.refundAmount;
            this.refundDate = rp.refundDateStr;
          } else {
            this.ShowError(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loader.hide();
        });
    },
  },
  mounted() {
    this.loadinit();
  },
};
</script>